class QuickPredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');

      let modalAlert = document.querySelector('#PopupModal-quickorder');
      /* if(window.globalVariables.cart.item_count > 0){
        modalAlert.querySelector('.modal').classList.add('open');
        siteOverlay.prototype.showOverlay();
      } */
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener('keydown', (event) => {
          if (event.keyCode === 13) {
              event.preventDefault();
          }
      });
      if (!sessionStorage.getItem("visitedOnce")) {
        if(window.globalVariables.cart.item_count == 0) {
          Utility.removeFromLocalStorage('QuickListProducts'); // Clear the QuickListProducts item from localStorage only when the cart is empty and the page is not refreshed.
        }
        sessionStorage.setItem("visitedOnce", "true");
      }
      this.retrieveQuickListProducts();
      this.bindEvents();
      this.bindQuickAdd();
      this.getTotal;
      document.querySelector('[data-add-new-line]').addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector('quick-predictive-search form').classList.remove('d-none');
      });


    }

    bindEvents(){
      let productsList = document.querySelectorAll('#predictive-search-results .list-item');
      let resultEl = document.querySelector('[data-quick-list-products]');

      document.querySelector('[data-quickorder-yes]').addEventListener('click', async (event) => {
        let websiteName = Utility.getCookie('websiteType');
        let locationID = Utility.getCookie('locationID');
        // alert(websiteName)
        // Utility.setCookie(`savecart_${websiteName}`,'');

        let requestData = {
          "customerId": window.globalVariables.customer_id,
          "cartType": websiteName,
          "location_id": locationID,
          "data": {}
        };
        // return false;
        try {
          const response = await fetch("https://shopifyapi2.jinny.com/api/update-cart", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(requestData),
          });
          const responseData = await response.json();
        } catch (e) {
          console.error(e);
          // Rollbar.error(`File: component-product-form.js, getting error in fetch inventory on onVariantChange: ${e}`);
        }

        // Utility.removeCookie(`savecart_barberunited`);
        var xhttp = new XMLHttpRequest();
        xhttp.open("POST", "/cart/clear.js", true);
        xhttp.send();

        
        setTimeout(function(){
          location.reload();
        },1000)
        
        
      });
      document.querySelector('[data-quickorder-no]').addEventListener('click', (event) => {
        window.location.href = Utility.getCookie('websiteURL');
      });
      
     
      productsList.forEach(el => {
        el.addEventListener('click', async (event) => {
          event.stopImmediatePropagation();
          event.preventDefault();
         
          let productHandle = event.target.closest('.list-item').getAttribute('data-quick-item-handle');
          let variantId = event.target.closest('.list-item').getAttribute('data-quick-item-id');
          
          document.querySelector('.site-loader').classList.add('loading');
          const product = await this._getProductFromHandle(productHandle);      
          // console.log('product==>',product);
          // document.querySelector('[data-quick-list-products]').classList.add('mt-4')
          let productHTML = document.querySelector('[data-quick-list-products]').innerHTML;
          let {productHTMLElement,responseData,APIFlag} = await this.getProductHTML(product,variantId);
          // console.log('APIFlag==>',APIFlag);
          if(APIFlag == false){
            document.querySelector('.site-loader').classList.remove('loading');
            return;
          }

          let searchQuickForm = event.target.closest('form');
          searchQuickForm.querySelector('input#Search').value = "";
          searchQuickForm.classList.add('d-none');
          document.querySelector('#predictive-search').style.display = 'none';
          document.querySelector('.site-loader').classList.remove('loading');
          
          productHTML += productHTMLElement;
          resultEl.innerHTML = productHTML;

          // Add minor delay to ensure HTML is rendered before running inventory logic
          setTimeout(() => {
            // console.log('responseData1111==>',responseData);
            if(responseData.inventory_policy == 'continue' && document.querySelector(`input[value="${variantId}"]`)){
              if(document.querySelector(`input[value="${variantId}"]`).closest('div')){
                document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').removeAttribute('data-totalavailable');
                document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg').innerHTML = '';
                document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = '';
              }
            }else if(responseData.inventory_policy != 'continue'){
              if(responseData.available == 0){
                if(document.querySelector(`input[value="${variantId}"]`).closest('div')){
                  document.querySelector(`input[value="${variantId}"]`).closest('div').setAttribute('data-not-consider',"false");
                  document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = 'This product is not available for the selected location.'
                }
              }else if(responseData.available > 0){
                if(document.querySelector(`input[value="${variantId}"]`).closest('div')){
                  let errormsgEl = document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg');
                  document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').setAttribute('data-totalavailable',responseData.available);
                  errormsgEl.innerHTML = `You can add ${responseData.available} quantities of this product to cart.`;
                  errormsgEl.classList.remove('d-none');
                  errormsgEl.style.display = '';
                  window.notificationEle.updateNotification('Quick Order', `Available: ${responseData.available} quantities. You can add up to ${responseData.available} to cart.`, {
                    timeout: 5000
                  });
                }
              }
            }
          }, 300);
          
          
          document.querySelector('.form-control.quick-order-form-search.active').classList.remove('active');

          let optionDropdowns = document.querySelectorAll('[data-option-select]');
          // optionDropdowns.forEach(optionDropdown => {
          //   optionDropdown?.addEventListener('change', async (event) => {
          //     event.stopImmediatePropagation();
          //     event.preventDefault();
          //     let options = this._getOptionsFromSelect(event);

          //     let producData = JSON.parse(event.target.closest('[data-product-listing ]').querySelector('[data-quick-products-json]').innerText);
          //     let variantsArray = producData.variants;
          //     let selectedVariant;
          //     variantsArray.find((variant) => {
          //       let mappedValues = variant.options.map((option, index) => {
          //         return options[index] === option;
          //       });
          
          //       if(!mappedValues.includes(false)){
          //         selectedVariant = variant;
          //       }
          //     });
             
          //     if(selectedVariant){

          //       const productVariantFqus = await this._getProductVariantFqu(productHandle, selectedVariant.id);
          //       let setFQU = 1;
          //       let case_quantity = 1;
          //       let sales_unit = "";
          //       let item_size = '';

          //       let productTags = (product.tags);
          //       productTags.forEach(tag => {
          //         if(tag.indexOf(Utility.getCookie('warehouseID')) > -1 && tag.indexOf('FQU') > -1){
          //           setFQU = tag.split('_').pop();
          //         }
          //         if(tag.indexOf('CQ') > -1){
          //           case_quantity = tag.split('_').pop();
          //         }
          //         if(tag.indexOf('SU') > -1){
          //           sales_unit = tag.split('_').pop();
          //         }
          //       });

          //       if (productVariantFqus && productVariantFqus != null) {
          //         if (productVariantFqus.FQU != null) {
          //           productVariantFqus.FQU.forEach(fqus => {
          //             if(fqus.indexOf(Utility.getCookie('warehouseID')) > -1 && fqus.indexOf('FQU') > -1){
          //               setFQU = fqus.split('_').pop();
          //               event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').dataset.fqu = setFQU;
          //               event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').value = setFQU;
          //               event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').setAttribute('value', setFQU);
          //             }
          //           });
          //         }
          //         if (productVariantFqus.CQ != null) {
          //           case_quantity = productVariantFqus.CQ;
          //         }
          //         if (productVariantFqus.SU != null) {
          //           sales_unit = productVariantFqus.SU;
          //         }
                 
          //         if (productVariantFqus.item_size != null) {
          //           item_size = productVariantFqus.item_size;
          //         }
          //       }
          //       console.log('item_size==>',item_size)

          //       event.target.closest('[data-product-listing]').querySelector('[data-additional-det]').innerHTML = `${item_size}/${case_quantity}/${sales_unit}`;
                
          //       // console.log('selectedVariant111', selectedVariant);
          //       if(event.target.closest('[data-product-listing]').querySelector('[name="quantity"]')){
          //         event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').dataset.fqu = setFQU;
          //         event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').value = setFQU;
          //         event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').setAttribute('value', setFQU);
          //       }
                
          //       if(event.target.closest('[data-product-listing]').querySelector('[data-quick-variant-id]')){
          //         event.target.closest('[data-product-listing]').querySelector('[data-quick-variant-id]').value = selectedVariant.id; 
          //         event.target.closest('[data-product-listing]').querySelector('[data-quick-variant-id]').setAttribute('value', selectedVariant.id);
          //       }
                
          //       if(event.target.closest('[data-product-listing]').querySelector('.quick-order-selected-variant-sku')){
          //         event.target.closest('[data-product-listing]').querySelector('.quick-order-selected-variant-sku').innerHTML = selectedVariant.sku;
          //       }
          //       if(event.target.closest('[data-product-listing]').querySelector('[name="quantity"]')){
          //         event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').value = event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').dataset.fqu;
          //         event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').setAttribute('value', event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').dataset.fqu);
          //       }

          //       if(event.target.closest('[data-product-listing]').querySelector('[data-casequantityquickorder]')){
          //         event.target.closest('[data-product-listing]').querySelector('[data-casequantityquickorder]').innerHTML = case_quantity;
          //       }
          //       if(event.target.closest('[data-product-listing]').querySelector('[data-fququickorder]')){
          //         event.target.closest('[data-product-listing]').querySelector('[data-fququickorder]').innerHTML = setFQU + " " + sales_unit;
          //       }

          //       if(Utility.getCookie('locationID') != ''){
          //         if(selectedVariant.inventory_management == "shopify"){
          //           let locationID = Utility.getCookie('locationID');
          //           let variantId = selectedVariant.id;
          //           let requestData = { 
          //             variant_id: variantId,
          //             location_id: locationID
          //           };
          //           fetch("https://shopifyapi2.jinny.com/api/fetch-inventory", {
          //           method: "POST",
          //           headers: {
          //               "Content-Type": "application/json",
          //               "Accept": "application/json"
          //           },
          //           body: JSON.stringify(requestData),
          //           }).then(response => {
          //             return response.json();
          //           }).then(response => {
          //             if(response.inventory_policy == 'continue' && document.querySelector(`input[value="${variantId}"]`)){
          //               if(document.querySelector(`input[value="${variantId}"]`).closest('div')){
          //                 document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').removeAttribute('data-totalavailable');
          //                 document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg').innerHTML = '';
          //                 document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = '';
          //               }
          //             }
          //             if(response.inventory_policy != 'continue'){
          //               document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').setAttribute('data-totalavailable',response.available);
                      
          //               if(selectedVariant.available == true){
          //                 document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg').innerHTML = `You can add ${response.available} quantities of this product to cart.`;
          //               }else{
          //                 document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg').innerHTML = '';
          //               }
          //               if(response.available == 0){
          //                 document.querySelector(`input[value="${variantId}"]`).closest('div').setAttribute('data-not-consider',"false");
          //                 document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = 'This product is not available for the selected location.';
          //               } else {
          //                 document.querySelector(`input[value="${variantId}"]`).closest('div').removeAttribute('data-not-consider');
          //                 document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = '';
          //               }
          //               // let qtyvalue = parseInt(document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').value);
          //               // document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').value = document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').getAttribute('data-fqu');

          //               document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-for="increase"]').classList.remove('disabled')

          //               let qtyValue = document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').value;
          //               let itemTotalPrice = selectedVariant.price * qtyValue;
          //               let cardEl = event.target.closest('[data-product-listing]');
          //               cardEl.querySelector('[data-total-price]').innerText = Utility.formatMoney(itemTotalPrice);
          //               this.storeQuickListProducts();
          //             }
                      
          //           });
          //         }
          //       }
          

               
          //       let cardEl = event.target.closest('[data-product-listing]');
          //       cardEl.querySelectorAll('[data-item-price]').forEach(el =>{
          //         el.setAttribute('data-item-price',selectedVariant.price)
          //       });
          //       cardEl.querySelector('[data-item-price] p').innerText = Utility.formatMoney(selectedVariant.price);
          //       let qtyVal = cardEl.querySelector('[data-qty-input]').value;
          //       let itemTotalPrice = selectedVariant.price * qtyVal;

          //       cardEl.querySelector('[data-total-price]').setAttribute('data-total-price', itemTotalPrice)
          //       cardEl.querySelector('[data-total-price]').innerText = Utility.formatMoney(itemTotalPrice);
          //       cardEl.setAttribute('data-available',selectedVariant.available);
          //       this.getTotal();
                

          //       if(selectedVariant.available == false){
          //         cardEl.querySelector('[data-error-msg]').innerHTML = `This variant is unavailable. Please select another option. This product will not added to cart while adding.`;
                  
          //       }else{
          //         cardEl.querySelector('[data-error-msg]').innerHTML = ``;
          //       }
          //     }
          //     else{
          //       const productVariantFqus = await this._getProductVariantFqu(productHandle, selectedVariant.id);
          //       let item_size = '';
          //       if(productVariantFqus.pdpitem_size != null){
          //         item_size = productVariantFqus.item_size;
          //       }
          //     }
          //     this.storeQuickListProducts();
          //   })
          // })

          this.bindQty();
          this.bindQuickAdd();
          this.getTotal();
          this.removeProduct();
          this.storeQuickListProducts();
        });
      });

    }
    removeProduct(){
      let removeEls = document.querySelectorAll('[data-item-remove]');
      removeEls.forEach(el => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          event.target.closest('[data-product-listing]')?.remove();
          this.getTotal();
          document.querySelector('quick-predictive-search form').classList.remove('d-none');
          this.storeQuickListProducts();
        });
      })
    }
    bindQty(){
      let qtyBtns = document.querySelectorAll('[data-quick-list-products] [data-qty-btn], [data-quick-list-products] [data-update-bulk-qty]');
      qtyBtns.forEach((qtyBtn) => {
        qtyBtn.addEventListener('click', (event) => {
          event.preventDefault();
          let itemPrice = event.target.closest('[data-qty-container]').querySelector('.input-group').getAttribute('data-item-price');
          this.manageQtyBtn(event,itemPrice);
        });
      });
      
      document.querySelectorAll('[data-qty-input]').forEach(el => {
        el.addEventListener('keyup', (event) => {
          event.preventDefault();
          let productListing = event.target.closest('[data-product-listing]');
          let itemPrice = event.target.closest('[data-qty-container]').querySelector('.input-group').getAttribute('data-item-price');
          let val = parseInt(event.currentTarget.value) || 1;
          event.currentTarget.setAttribute('value',val);
          
          // Get volume pricing if configured
          let priceBreaksAttr = productListing.getAttribute('data-price-breaks');
          let effectivePrice = parseFloat(itemPrice);
          
          if (priceBreaksAttr) {
            try {
              let priceBreaks = JSON.parse(priceBreaksAttr);
              let basePrice = parseFloat(productListing.querySelector('[data-item-price]').getAttribute('data-base-price')) || effectivePrice;
              effectivePrice = basePrice; // Start with base price
              
              // Find the applicable price break tier
              for (let i = priceBreaks.length - 1; i >= 0; i--) {
                if (val >= priceBreaks[i].minimum_quantity) {
                  effectivePrice = priceBreaks[i].price;
                  break;
                }
              }
              
              // Update the unit price display
              productListing.querySelector('[data-item-price]').setAttribute('data-item-price', effectivePrice);
              if (productListing.querySelector('[data-unit-price]')) {
                productListing.querySelector('[data-unit-price]').innerText = Utility.formatMoney(effectivePrice);
              }
              
              // Update save percentage badge
              let savePercentageBadge = productListing.querySelector('[data-save-percentage]');
              if (savePercentageBadge) {
                if (basePrice > 0 && effectivePrice < basePrice) {
                  let savePercentage = Math.round(((basePrice - effectivePrice) / basePrice) * 100);
                  savePercentageBadge.innerText = `Save ${savePercentage}%`;
                  savePercentageBadge.classList.remove('d-none');
                } else {
                  savePercentageBadge.classList.add('d-none');
                }
              }
            } catch (e) {
              console.error('Error parsing price breaks:', e);
            }
          }
          
          let totalPrice = effectivePrice * val;
          event.target.closest('[data-product-listing]').querySelector('[data-total-price]').innerText = Utility.formatMoney(totalPrice);
          event.target.closest('[data-product-listing]').querySelector('[data-total-price]').setAttribute('data-total-price', totalPrice)

          this.getTotal();

        });
      });
    }
    manageQtyBtn(event,itemPrice){
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let currentQty = parseInt($qtyInput.value) || 1;
      let finalQty = 1;
      let fquQty = parseInt($qtyInput.getAttribute('data-fqu'));
      let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');
      let increaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="increase"]');
      let decreaseQtyBtnBulk = currentTarget.closest('[data-qty-container]').querySelector('[data-for-bulk="decrease"]');
      let increaseQtyBtnBulk = currentTarget.closest('[data-qty-container]').querySelector('[data-for-bulk="increase"]');
      let data_qty_bulk_number = 1;

      if($qtyInput.getAttribute('data-qty-bulk-number')){
        data_qty_bulk_number = parseInt($qtyInput.getAttribute('data-qty-bulk-number'));
      }

      if((action == 'decrease' || event.currentTarget.dataset.forBulk == 'decrease') && currentQty <= 1){
        if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
        if(decreaseQtyBtnBulk) decreaseQtyBtnBulk.classList.add('disabled');
        return false;
      }else if(action == 'decrease' || event.currentTarget.dataset.forBulk == 'decrease'){
        if(currentQty != fquQty){
          if (event.currentTarget.dataset.forBulk == 'decrease') {
            finalQty = currentQty - data_qty_bulk_number;
  
            // Ensure finalQty is a multiple of FQU
            finalQty = Math.round(finalQty / fquQty) * fquQty;
            finalQty = Math.max(finalQty, fquQty);
          } else {
            finalQty = currentQty - fquQty;
          }

          finalQty == fquQty ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
          finalQty == fquQty ? decreaseQtyBtnBulk?.classList.add('disabled') : decreaseQtyBtnBulk?.classList.remove('disabled');
        }else{
          return false;
        }
      }else{
        if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
        if(decreaseQtyBtnBulk) decreaseQtyBtnBulk.classList.remove('disabled');
        if (event.currentTarget.dataset.forBulk == 'increase') {
          finalQty = currentQty + data_qty_bulk_number;

          // Ensure finalQty is a multiple of FQU
          finalQty = Math.round(finalQty / fquQty) * fquQty;
          finalQty = Math.max(finalQty, fquQty);
        } else {
          finalQty = currentQty + fquQty;
        }
      }

      let availableQty = parseInt($qtyInput.getAttribute('data-totalavailable'));

      if(finalQty > availableQty){
        if(fquQty < finalQty){
          return false;
        }
        increaseQtyBtn.classList.add('disabled');
        increaseQtyBtnBulk?.classList.add('disabled');
      }else{
        increaseQtyBtn.classList.remove('disabled');
        increaseQtyBtnBulk?.classList.remove('disabled');
      }
  
      $qtyInput.value = finalQty;
      $qtyInput.setAttribute('value', finalQty);
      $qtyInput.setAttribute('value',finalQty)
      
      let availableQtyAttr = $qtyInput.getAttribute('data-totalavailable');
      if (availableQtyAttr != null && parseInt(availableQtyAttr, 10) === finalQty) {
        window.notificationEle.updateNotification('Quantity Updated', `Quantity reached available limit (${availableQtyAttr}).`, {
          timeout: 4000
        });
      }

      // Get volume pricing if configured
      let productListing = currentTarget.closest('[data-product-listing]');
      let priceBreaksAttr = productListing.getAttribute('data-price-breaks');
      let effectivePrice = itemPrice;
      
      if (priceBreaksAttr) {
        try {
          let priceBreaks = JSON.parse(priceBreaksAttr);
          let basePrice = parseFloat(productListing.querySelector('[data-item-price]').getAttribute('data-base-price')) || itemPrice;
          effectivePrice = basePrice; // Start with base price
          
          // Find the applicable price break tier (iterate from highest to lowest)
          for (let i = priceBreaks.length - 1; i >= 0; i--) {
            if (finalQty >= priceBreaks[i].minimum_quantity) {
              effectivePrice = priceBreaks[i].price;
              break;
            }
          }
          
          // Update the unit price display
          productListing.querySelector('[data-item-price]').setAttribute('data-item-price', effectivePrice);
          if (productListing.querySelector('[data-unit-price]')) {
            productListing.querySelector('[data-unit-price]').innerText = Utility.formatMoney(effectivePrice);
          }
          
          // Update save percentage badge
          let savePercentageBadge = productListing.querySelector('[data-save-percentage]');
          if (savePercentageBadge) {
            if (basePrice > 0 && effectivePrice < basePrice) {
              let savePercentage = Math.round(((basePrice - effectivePrice) / basePrice) * 100);
              savePercentageBadge.innerText = `Save ${savePercentage}%`;
              savePercentageBadge.classList.remove('d-none');
            } else {
              savePercentageBadge.classList.add('d-none');
            }
          }
        } catch (e) {
          console.error('Error parsing price breaks:', e);
        }
      }
      
      let totalPrice = effectivePrice * finalQty;
      currentTarget.closest('[data-product-listing]').querySelector('[data-total-price]').innerText = Utility.formatMoney(totalPrice);
      currentTarget.closest('[data-product-listing]').querySelector('[data-total-price]').setAttribute('data-total-price', totalPrice)
      this.getTotal();
      this.storeQuickListProducts();
    }

    getTotal(){
      let itemTotalEls = document.querySelectorAll('[data-total-price]');
      let subTotal = 0;

      itemTotalEls.forEach(el => {
        let total = parseFloat(el.getAttribute('data-total-price'));
        subTotal += total;
      });

      let listingToMinus = document.querySelectorAll('[data-product-listing][data-available="false"]');
      let subMinus = 0;
      listingToMinus.forEach(el => {
        let total = parseFloat(el.querySelector('[data-total-price]').getAttribute('data-total-price'));
        subMinus += total;
      });

      let mainTotal = subTotal - subMinus;
      document.querySelector('[data-subtotal-price]').innerText = Utility.formatMoney(mainTotal);
      
    }
    bindQuickAdd(){
      document.querySelector('[data-quick-products-add]').addEventListener('click', async (event) => {
        event.preventDefault();
        let _this = event.currentTarget;
       
        let lineItem = [];
        let lineItemsvariantIDs = [];
        document.querySelectorAll('[data-quick-list-products] [data-product-listing]:not([data-quick-list-products] [data-product-listing][data-not-consider="false"])').forEach((el) => {
          let variantID = el.querySelector('[data-quick-variant-id]').value;
          let qty = el.querySelector('[data-qty-input]').value;
          let _fqu = el.querySelector('[data-qty-input]').getAttribute('data-fqu');
          let _availableinventory = el.querySelector('[data-qty-input]').getAttribute('data-totalavailable');
          lineItemsvariantIDs.push(variantID);
          let data = {
            "id":variantID,
            "quantity":qty,
            "properties": {
              _fqu,
              _availableinventory
            }
          }
          lineItem.push(data);
        });

        if (lineItemsvariantIDs.length > 0) {
          _this.classList.add('loading');
          await this.filterRemoveVariantsFromCart(lineItemsvariantIDs);
        }

        if(lineItem.length > 0){
          _this.classList.add('loading')
          fetch('/cart/add.js', {
            method: "post",
            headers: { 'content-type': 'application/json' },
              body: JSON.stringify({
                  items: lineItem
              })
          }).then(function(data) {
            _this.classList.remove('loading');

            let sectionID = 'component-cart-drawer';
            let cartRoute = `${window.location.pathname}?sections=${sectionID},header`;
            fetch(cartRoute).then(response => {
              return response.json();
            }).then(response => {
                let cartElement = document.querySelector('cart-form'); 
                cartElement._updateCart(response, '', 'updateCart');
            }).catch((e) => {
                console.error(e);
                window.Rollbar?.error(`File: quick-order-search.js, getting error on bindQuickAdd: ${e}`);
            }).finally(() => {
              sessionStorage.removeItem("visitedOnce");
              // console.log(' window.globalVariables.cart', window.globalVariables.cart)
              if(data.ok == true){
                let totalUnits = lineItem.reduce((sum, item) => sum + parseInt(item.quantity, 10), 0);
                let productCount = lineItem.length;
                let successMsg = productCount === 1
                  ? `${totalUnits} unit${totalUnits !== 1 ? 's' : ''} added to cart.`
                  : `${productCount} products (${totalUnits} units) added to cart.`;
                window.notificationEle.updateNotification('Add to Cart', successMsg, {
                  type: 'success',
                  timeout: 5000
                });
                window.location.href = '/cart';
              } else {
                if(lineItem.length == 1){
                  window.notificationEle.updateNotification('Add To Cart', 'Item is out of stock', {
                    type: 'error',
                    timeout: 7000
                  });
                }else{
                  window.notificationEle.updateNotification('Add To Cart', 'Some of Items are out of stock', {
                    type: 'error',
                    timeout: 7000
                  });
                  window.location.href = '/cart';
                }
                

              }
                // Cart HTML fetch done
            });
            
            
            
          
          }).catch(function(error) {
            _this.classList.remove('loading')
            console.log(error);
          });
        }

      })
    }
    _getOptionsFromSelect(event) {
      let options = [];
      event.target.closest('[data-product-listing]').querySelectorAll('[data-option-select]').forEach((selector)=>{
        selector.querySelectorAll('option').forEach((option)=>{
          if(option.value == selector.value){
            option.setAttribute('selected',true)
          }else{
            option.removeAttribute('selected')
          }
        }); 
        options.push(selector.value);
      });
      
      return options;
    }
   
    async _getProductFromHandle(handle){
      const response = await fetch(`/products/${handle}.js`);
      const data = await response.json();
      if(response.ok){
        return data;
      } else {
        window.notificationEle.updateNotification('Something went wrong', 'Please try again later', {
          type: 'error',
          timeout: 5000
        });
        window.Rollbar?.error(`File: quick-order-search.js, getting error on _getProductFromHandle`);
      }
     
    }

    async _getProductVariantFqu(handle, variantid){
      // Parse only after the status check, and guard the parse: a missing or renamed
      // alternate template makes Shopify serve the ordinary HTML product page with 200 OK,
      // and a 404 handle serves the HTML 404 page. Either one used to throw out of here,
      // past every caller, leaving the full-screen .site-loader overlay spinning forever.
      try {
        const response = await fetch(`/products/${handle}?variant=${variantid}&view=product-variant-fqu-data`);
        if(response.ok){
          return await response.json();
        }
      } catch (e) {
        // fall through to the notification below
      }
      window.notificationEle.updateNotification('Something went wrong', 'Please try again later', {
        type: 'error',
        timeout: 5000
      });
    }

    async getProductHTML(product,variantId){
      var allProductOptions = "";
      for(const option of product.options){
        // Original dropdown code - commented out for backup
        /*
        let optionHtml = ``;
        let isOptions = false;
        for (const value of option.values) { 
          if(value != 'Default Title'){
            isOptions = true;
            let temp = `<option value='${value}'>${value}</option>`;
            optionHtml += temp;
          }
        }
        if(isOptions){
          let tempHtml = `
            <div class="d-flex align-items-center ms-n1">
              <h6 class="p-1 font-size-14 form__label fw-bold lh-sm ls-sm mb-0 text-primary text-uppercase" >${option.name}:</h6>
              <div class="p-1">
                <select class="form-select rounded-2 py-1 ps-3 w-auto" data-option-select>
                  ${optionHtml}
                </select>
              </div>
            </div>
          `;
          allProductOptions += tempHtml;
        }
        */
        
        // New plain text code
        let isOptions = false;
        let selectedValue = '';
        
        // Find the selected value for this option
        for (const value of option.values) { 
          if(value != 'Default Title'){
            isOptions = true;
            // Get the selected variant to find the current option value
            let getVariant = product.variants.find(variant => variant.id == variantId);
            if (getVariant && getVariant.options) {
              // Find which option index this is (0, 1, 2, etc.)
              let optionIndex = product.options.findIndex(opt => opt.name === option.name);
              if (optionIndex >= 0 && getVariant.options[optionIndex]) {
                selectedValue = getVariant.options[optionIndex];
              }
            }
            break; // We only need the first valid value to determine if options exist
          }
        }
        
        if(isOptions && selectedValue){
          let tempHtml = `
            <div class="d-block w-100">
              <h6 class="p-1 ps-0 font-size-14 form__label fw-bold lh-sm ls-sm mb-0 text-primary text-uppercase d-inline-block" >${option.name}:</h6>
              <span class="fs-md ms-1">${selectedValue}</span>
            </div>
          `;
          allProductOptions += tempHtml;
        }
        
      }

      let productTags = (product.tags);
      let setFQU = 1;
      let case_quantity = 1;
      let sales_unit = "";
      let item_size = '';
      productTags.forEach(tag => {
        // if(tag.indexOf(`FQU_${Utility.getCookie('warehouseID')}`) > -1){
        if(tag.indexOf(Utility.getCookie('warehouseID')) > -1 && tag.indexOf('FQU') > -1){
          setFQU = tag.split('_').pop();
        }
        if(tag.indexOf('CQ') > -1){
          case_quantity = tag.split('_').pop();
        }
        if(tag.indexOf('SU') > -1){
          sales_unit = tag.split('_').pop();
        }
      });
      


      // if (product.variants.length > 0) {
        const productVariantFqus = await this._getProductVariantFqu(product.handle, variantId);
        if (productVariantFqus && productVariantFqus != null) {
          if (productVariantFqus.FQU != null) {
            productVariantFqus.FQU.forEach(fqus => {
              if(fqus.indexOf(Utility.getCookie('warehouseID')) > -1 && fqus.indexOf('FQU') > -1){
                setFQU = fqus.split('_').pop();
              }
            });
          }
          if (productVariantFqus.CQ != null) {
            case_quantity = productVariantFqus.CQ;
          }
          if (productVariantFqus.SU != null) {
            sales_unit = productVariantFqus.SU;
          }
          
        }
        if(productVariantFqus?.pdpitem_size != null){
            item_size = productVariantFqus.pdpitem_size;
        }
        if(productVariantFqus?.item_size != null){
            item_size = productVariantFqus.item_size;
        }

        // B2B Catalog Pricing - Volume Price Breaks
        let quantityPriceBreaksConfigured = productVariantFqus?.quantity_price_breaks_configured || false;
        let quantityPriceBreaks = productVariantFqus?.quantity_price_breaks || [];

        // console.log('fququickorder=item_size=>',item_size)

        
        
      let getVariant = product.variants.find(variant => variant.id == variantId);
      let productImage = '/cdn/shop/files/no-image.jpg?height=90&v=1789573800';
      // console.log('getVariant==>',getVariant);
      if(getVariant.featured_image && getVariant.featured_image.src){
        productImage = getVariant.featured_image.src;
      }else if(product.featured_image){
        productImage = product.featured_image;
      }

      let APIFlag = false;
      let responseData = {};
      if(Utility.getCookie('locationID') != ''){
        if(getVariant.inventory_management == "shopify"){
          let variantId = getVariant.id;
          try {
            // Same handle and variant the FQU payload above was fetched for, so read the
            // inventory off it instead of fetching the same document a second time.
            responseData = Utility.inventoryFrom(productVariantFqus);

            if(responseData.message){
              // Lookup failed - say so instead of telling the buyer it is out of stock.
              document.querySelector('.site-loader').classList.remove('loading');
              window.notificationEle.updateNotification('Stock check failed', 'Could not check stock for this item. Please try again.', {
                type: 'error',
                timeout: 7000
              });
            }else if(responseData.inventory_policy != 'continue' && responseData.available <= 0){
              document.querySelector('.site-loader').classList.remove('loading');
              window.notificationEle.updateNotification('Out of Stock', 'Item is out of stock', {
                type: 'error',
                timeout: 7000
              });
            }else{
              APIFlag = true;
            }

            // if(responseData.inventory_policy == 'continue' && document.querySelector(`input[value="${variantId}"]`)){
            //   if(document.querySelector(`input[value="${variantId}"]`).closest('div')){
            //     document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').removeAttribute('data-totalavailable');
            //     document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg').innerHTML = '';
            //     document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = '';
            //   }
            // }else if(responseData.inventory_policy != 'continue'){
            //   if(responseData.available == 0){
            //     if(document.querySelector(`input[value="${variantId}"]`).closest('div')){
            //       document.querySelector(`input[value="${variantId}"]`).closest('div').setAttribute('data-not-consider',"false");
            //       document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = 'This product is not available for the selected location.'
            //     }
            //   }else if(responseData.available > 0){
            //     if(document.querySelector(`input[value="${variantId}"]`).closest('div')){
            //       document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').setAttribute('data-totalavailable',responseData.available);
            //       document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg').innerHTML = `You can add ${responseData.available} quantities of this product to cart.`;
            //     }
            //   }
            // }
          } catch (e) {
            console.error(e);
            window.Rollbar?.error(`File: quick-order-search.js, getting error in fetch inventory on getProductHTML: ${e}`);
          }
        }
      }


      // Build price breaks data attribute if configured
      let priceBreakDataAttr = '';
      if (quantityPriceBreaksConfigured && quantityPriceBreaks.length > 0) {
        priceBreakDataAttr = `data-price-breaks='${JSON.stringify(quantityPriceBreaks)}'`;
      }

      // Determine initial price based on quantity and price breaks
      let initialPrice = getVariant.price;
      let initialDisplayPrice = getVariant.price;
      let savePercentage = 0;
      if (quantityPriceBreaksConfigured && quantityPriceBreaks.length > 0) {
        // Check if FQU meets any price break threshold
        for (let i = quantityPriceBreaks.length - 1; i >= 0; i--) {
          if (parseInt(setFQU) >= quantityPriceBreaks[i].minimum_quantity) {
            initialDisplayPrice = quantityPriceBreaks[i].price;
            // Calculate save percentage
            if (getVariant.price > 0 && initialDisplayPrice < getVariant.price) {
              savePercentage = Math.round(((getVariant.price - initialDisplayPrice) / getVariant.price) * 100);
            }
            break;
          }
        }
      }
      
      // Build save percentage badge HTML
      let savePercentageHTML = savePercentage > 0 
        ? `<span class="save-percentage-badge text-danger fw-bold fs-sm ms-1" data-save-percentage>Save ${savePercentage}%</span>` 
        : `<span class="save-percentage-badge text-danger fw-bold fs-sm ms-1 d-none" data-save-percentage></span>`;

      // Build Volume Pricing Available section
      let volumePricingAvailableHTML = '';
      if (quantityPriceBreaksConfigured && quantityPriceBreaks.length > 0) {
        volumePricingAvailableHTML = `
          <div class="volume-pricing-available mt-2" data-volume-pricing-available>
            <div class="d-flex align-items-center">
              <span class="fs-md fw-normal lh-sm ls-1">Volume Pricing Available</span>
            </div>
          </div>
        `;
      }

      let productHTMLElement = `
        <div class="py-4 border-bottom" data-product-tags="${product.tags}" data-product-listing data-id= "${product.id}" data-available="${getVariant.available}" data-product-handle="${product.handle}" ${priceBreakDataAttr}>
        <input type="hidden" value="${getVariant.id}" data-quick-variant-id/>
          <div class="row">
              <div class="col-12 col-lg-4 mb-3 mb-md-0">
                  <div class="d-flex quick-order-img">
                    <a href="${product.url + '?variant=' + getVariant.id}">
                      <img src="${productImage}&width=168" height="100" width="100" alt="quick-order-img" loading="eager" class="w-100 h-100 object-fit-contain bg-gray-100">
                    </a>
                      <div class="ps-3 lh-1">
                          <a href="${product.url + '?variant=' + getVariant.id}" class="d-inline-block mb-2 pb-1 fw-bold fs-md text-body">
                            <p class="mb-0">${product.title}</p>
                          </a>
                          <div class="d-flex">
                          <div class="w-100">
                          <div class="d-flex flex-wrap fw-normal fs-md">
                            ${allProductOptions}
                            <div class="d-flex align-items-center ms-n1 w-100 mt-2">
                              SKU <span class="quick-order-selected-variant-sku ms-1"> ${getVariant.sku}</span>
                            </div>
                          </div>
                          <div data-additional-det="" class="fs-md mt-1 ms-n1">${item_size}/${case_quantity}/${sales_unit}</div>
                          </div>
                          <div class="">
                          ${volumePricingAvailableHTML}
                          </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-12 col-lg-8 d-flex flex-wrap quick-order-row-2">
                  <div class="col-2 col-lg-3 pt-2 mt-1 lh-1 fw-normal fs-md" data-item-price="${initialDisplayPrice}" data-base-price="${getVariant.price}">
                      <p class="mb-0 pt-1 d-inline-block" data-unit-price>${Utility.formatMoney(initialDisplayPrice)}</p>
                      ${savePercentageHTML}
                  </div>
                  
                  <div class="col-6 col-lg-6">
                    <div class="align-items-center d-flex justify-content-center justify-content-lg-start quantity-wrapper pe-lg-3" data-qty-container>

                    ${window.globalVariables.editable_qty_bulk_number != 0 ? `<button type="button" class="btn-text" data-for-bulk="decrease" data-update-bulk-qty>-${window.globalVariables.editable_qty_bulk_number}</button>` : ''}

                    <div class="input-group" data-item-price="${getVariant.price}">
                        <div class="input-group-prepend position-absolute z-index-1 h-100 start-0">
                            <a href="#" class="input-group-text border-0 min-h-100 disabled" rel="nofollow" aria-label="{{ 'products.product.quantity.decrease' | t: product: product.title | escape }}" title="{{ 'products.product.quantity.decrease' | t: product: product.title | escape }}" data-for="decrease" data-qty-btn>
                            <span class="btn-decrease d-flex">
                              <svg width="14" height="2" viewBox="0 0 14 2" xmlns="http://www.w3.org/2000/svg"><use href="#icon-minus"></use></svg>
                            </span>
                            <span class="visually-hidden">{{ 'products.product.quantity.decrease' | t: product: product.title | escape }}</span>
                            </a>
                        </div>
                        <input data-fqu=${setFQU} type="text" readonly name="quantity"  id="updates_${product.id}" aria-label="${product.title}"  value="${setFQU}" step="1" min="1" inputmode="numeric" data-qty-input class="px-2 quantity form-control text-center" ${window.globalVariables.editable_qty_bulk_number != 0 ? `data-qty-bulk-number="${window.globalVariables.editable_qty_bulk_number}"` : ''}>
                        <div class="input-group-append position-absolute z-index-1 h-100 end-0">
                            <a href="#" class="input-group-text border-0 min-h-100" rel="nofollow" aria-label="{{ 'products.product.quantity.increase' | t: product: product.title | escape }}" title="{{ 'products.product.quantity.increase' | t: product: product.title | escape }}" data-for="increase" data-qty-btn>
                            <span class="btn-increase btn-increase d-flex h-100 align-items-center">
                              <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><use href="#icon-plus"></use></svg>
                            </span>
                            <span class="visually-hidden">{{ 'products.product.quantity.increase' | t: product: product.title | escape }}</span>
                            </a>
                        </div>
                      </div>
                      ${window.globalVariables.editable_qty_bulk_number != 0 ? `<button type="button" class="btn-text" data-for-bulk="increase" data-update-bulk-qty>+${window.globalVariables.editable_qty_bulk_number}</button>` : ''}
                        

                      
                    <span class="d-inline-block d-md-none ms-2" data-item-remove><svg width="18" height="20" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg"><use href="#icon-remove"></use></svg></span>
                      
                    </div>
                    <div class="errormsg fs-sm text-primary-700 mt-1 text-center text-lg-start pe-lg-3 d-none" style="display: none;"></div>
                    <div class="errormsgmain fs-sm text-danger mt-1 text-center text-lg-start pe-lg-3"></div>
                  </div>
                  <div class="col-12 col-lg-3">
                      <div class="d-lg-flex justify-content-lg-between pt-2 mt-1 lh-1 fw-bold fs-md">
                          <p class="mb-0 b-0 pt-1 text-end text-lg-start" data-total-price="${initialDisplayPrice * setFQU}"> ${Utility.formatMoney(initialDisplayPrice * setFQU)} </p>
                          <span class="d-none d-lg-block" data-item-remove> <svg width="18" height="20" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg"><use href="#icon-remove"></use></svg></span>
                      </div>
                  </div>
              </div>
              <div class="col-12 text-danger fs-sm mt-2" data-error-msg></div>
          </div>
          <script data-quick-products-json type="application/json">
            ${JSON.stringify(product)}
          </script>
        </div>
      `;

      // if(checkfornotAdd == true){
      //   productHTML = "";
      // }
      
      return  {productHTMLElement,responseData,APIFlag};
      
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      // console.log('getSearchResults');
      fetch(`/search/suggest?q=${searchTerm}&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,tag,body&section_id=predictive-search&section_id=quick-predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-quick-predictive-search').innerHTML;
          // console.log('resultsMarkup==>',resultsMarkup);
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          if((this.predictiveSearchResults.textContent.trim()).length == 0){
            this.predictiveSearchResults.innerHTML = `<div id="predictive-search-results" class="quick-add bg-white position-absolute border-end border-start border-bottom px-3 py-3">No Products found.</div>`;
          }else{
            let products = this.predictiveSearchResults.querySelectorAll('[data-quick-product-tags]');
            products.forEach(product => {
              let productTags = (product.getAttribute('data-quick-product-tags')).split(',');
              if(productTags.includes(Utility.getCookie('websiteType'))){
                product.classList.remove('d-none');
              }else{
                product.classList.add('d-none');
              }
            });
            this.open();
            this.bindEvents();
          }
        })
        .catch((error) => {
          window.Rollbar?.error(`File: quick-order-search.js, getting error on getSearchResults: ${error}`);
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
      this.input.classList.add('active')
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.input.classList.remove('active')
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    async filterRemoveVariantsFromCart(variantIds) {
      const cart = window.globalVariables.cart;
      const updates = {};
    
      // Match by variant_id and use line number (index + 1)
      cart.items.forEach((item, index) => {
        if (variantIds.includes(String(item.variant_id))) {
          updates[item.variant_id] = 0;
        }
      });
    
      if (Object.keys(updates).length === 0) {
        // console.log('No matching variant IDs found in cart. Nothing to remove.');
        return;
      }
    
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        });
    
        if (!response.ok) {
          throw new Error(`Cart update failed with status ${response.status}`);
        }
        let websiteName = Utility.getCookie('websiteType');
        let locationID = Utility.getCookie('locationID');
        Utility.setCookie(`savecart_${websiteName}`,'');

        let requestData = {
          "customerId": window.globalVariables.customer_id,
          "cartType": websiteName,
          "location_id": locationID,
          "data": {}
        };
        // return false;
        try {
          const response = await fetch("https://shopifyapi2.jinny.com/api/update-cart", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(requestData),
          });
          const responseData = await response.json();
        } catch (e) {
          console.error(e);
          // Rollbar.error(`File: component-product-form.js, getting error in fetch inventory on onVariantChange: ${e}`);
        }

      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }

    async variantChange() {
      let optionDropdowns = document.querySelectorAll('[data-option-select]');
      optionDropdowns.forEach(optionDropdown => {
        optionDropdown?.addEventListener('change', async (event) => {
          event.stopImmediatePropagation();
          event.preventDefault();
          let options = this._getOptionsFromSelect(event);

          let producData = JSON.parse(event.target.closest('[data-product-listing ]').querySelector('[data-quick-products-json]').innerText);
          let productHandle = event.target.closest('[data-product-listing]').dataset.productHandle;
          let variantsArray = producData.variants;
          let selectedVariant;
          variantsArray.find((variant) => {
            let mappedValues = variant.options.map((option, index) => {
              return options[index] === option;
            });
      
            if(!mappedValues.includes(false)){
              selectedVariant = variant;
            }
          });
          
          if(selectedVariant){

            const productVariantFqus = await this._getProductVariantFqu(productHandle, selectedVariant.id);
            let setFQU = 1;
            let case_quantity = 1;
            let sales_unit = "";
            let item_size = "";

            let productTags = event.target.closest('[data-product-listing]').dataset.productTags.split(',');
            productTags.forEach(tag => {
              if(tag.indexOf(Utility.getCookie('warehouseID')) > -1 && tag.indexOf('FQU') > -1){
                setFQU = tag.split('_').pop();
              }
              if(tag.indexOf('CQ') > -1){
                case_quantity = tag.split('_').pop();
              }
              if(tag.indexOf('SU') > -1){
                sales_unit = tag.split('_').pop();
              }
            });

            if (productVariantFqus && productVariantFqus != null) {
              if (productVariantFqus.FQU != null) {
                productVariantFqus.FQU.forEach(fqus => {
                  if(fqus.indexOf(Utility.getCookie('warehouseID')) > -1 && fqus.indexOf('FQU') > -1){
                    setFQU = fqus.split('_').pop();
                    event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').dataset.fqu = setFQU;
                    event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').value = setFQU;
                    event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').setAttribute('value', setFQU);
                  }
                });
              }
              if (productVariantFqus.CQ != null) {
                case_quantity = productVariantFqus.CQ;
              }
              if (productVariantFqus.SU != null) {
                sales_unit = productVariantFqus.SU;
              }
              if(productVariantFqus.pdpitem_size != null){
                  item_size = productVariantFqus.pdpitem_size;
              }
              if(productVariantFqus.item_size != null){
                  item_size = productVariantFqus.item_size;
              }
              
              // B2B Catalog Pricing - Volume Price Breaks
              let quantityPriceBreaksConfigured = productVariantFqus.quantity_price_breaks_configured || false;
              let quantityPriceBreaks = productVariantFqus.quantity_price_breaks || [];
              let productListing = event.target.closest('[data-product-listing]');
              
              // Update price breaks data attribute
              if (quantityPriceBreaksConfigured && quantityPriceBreaks.length > 0) {
                productListing.setAttribute('data-price-breaks', JSON.stringify(quantityPriceBreaks));
                
                // Ensure save percentage badge exists
                let savePercentageBadge = productListing.querySelector('[data-save-percentage]');
                if (!savePercentageBadge) {
                  let priceContainer = productListing.querySelector('[data-item-price]');
                  if (priceContainer) {
                    priceContainer.insertAdjacentHTML('beforeend', `<span class="save-percentage-badge text-danger fw-bold fs-sm ms-1 d-none" data-save-percentage></span>`);
                  }
                }
                
                // Update or create Volume Pricing Available section
                let priceBreakDescriptions = quantityPriceBreaks.map(pb => 
                  `Buy ${pb.minimum_quantity}+ @ ${Utility.formatMoney(pb.price)}`
                ).join(' | ');
                
                let volumePricingAvailable = productListing.querySelector('[data-volume-pricing-available]');
                if (volumePricingAvailable) {
                  // Update existing description
                  let descEl = volumePricingAvailable.querySelector('[data-volume-pricing-description]');
                  if (descEl) {
                    descEl.innerText = priceBreakDescriptions;
                  }
                } else {
                  // Create new Volume Pricing Available section
                  let volumePricingAvailableHTML = `
                    <div class="volume-pricing-available mt-2" data-volume-pricing-available>
                      <div class="d-flex align-items-center">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-1">
                          <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="fw-bold text-success fs-sm">Volume Pricing Available</span>
                      </div>
                      <p class="mb-0 fs-xs text-muted mt-1" data-volume-pricing-description>${priceBreakDescriptions}</p>
                    </div>
                  `;
                  let additionalDetEl = productListing.querySelector('[data-additional-det]');
                  if (additionalDetEl) {
                    additionalDetEl.insertAdjacentHTML('afterend', volumePricingAvailableHTML);
                  }
                }
              } else {
                productListing.removeAttribute('data-price-breaks');
                // Remove Volume Pricing Available section if no price breaks
                let volumePricingAvailable = productListing.querySelector('[data-volume-pricing-available]');
                if (volumePricingAvailable) {
                  volumePricingAvailable.remove();
                }
              }
            }
            
            // console.log('item_size',item_size)
            if(event.target.closest('[data-product-listing]').querySelector('[name="quantity"]')){
              event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').dataset.fqu = setFQU;
              event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').value = setFQU;
              event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').setAttribute('value', setFQU);
            }

            if(event.target.closest('[data-product-listing]').querySelector('[data-quick-variant-id]')){
              event.target.closest('[data-product-listing]').querySelector('[data-quick-variant-id]').value = selectedVariant.id;
              event.target.closest('[data-product-listing]').querySelector('[data-quick-variant-id]').setAttribute('value', selectedVariant.id);
            }
            if(event.target.closest('[data-product-listing]').querySelector('.quick-order-selected-variant-sku')){
              event.target.closest('[data-product-listing]').querySelector('.quick-order-selected-variant-sku').innerHTML = selectedVariant.sku;
            }
            if(event.target.closest('[data-product-listing]').querySelector('[name="quantity"]')){
              event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').value = event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').dataset.fqu;
              event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').setAttribute('value', event.target.closest('[data-product-listing]').querySelector('[name="quantity"]').dataset.fqu);
            }

            if(event.target.closest('[data-product-listing]').querySelector('[data-casequantityquickorder]')){
              event.target.closest('[data-product-listing]').querySelector('[data-casequantityquickorder]').innerHTML = case_quantity;
            }
            if(event.target.closest('[data-product-listing]').querySelector('[data-fququickorder]')){
              event.target.closest('[data-product-listing]').querySelector('[data-fququickorder]').innerHTML = setFQU + " " + sales_unit;
            }

            event.target.closest('[data-product-listing]').querySelector('[data-additional-det]').innerHTML = `${item_size}/${case_quantity}/${sales_unit}`;

            // event.target.closest('[data-product-listing]').querySelector('[data-casequantityquickorder]').innerHTML = case_quantity;
            // event.target.closest('[data-product-listing]').querySelector('[data-fququickorder]').innerHTML = setFQU + " " + sales_unit;
            // console.log('selectedVariant333', selectedVariant);

            if(Utility.getCookie('locationID') != ''){
              if(selectedVariant.inventory_management == "shopify"){
                let variantId = selectedVariant.id;
                // Same handle and variant the FQU payload above was fetched for. Left on a
                // promise so the price/total writes further down this handler still land
                // before these inventory writes, exactly as they did with the fetch.
                Promise.resolve(Utility.inventoryFrom(productVariantFqus)).then(response => {
                  if(response.message){
                    // Same rule as retrieveQuickListProducts: not a stockout, but not orderable
                    // either until we can verify it.
                    const failRow = event.target.closest('[data-product-listing]');
                    failRow.setAttribute('data-not-consider', 'false');
                    failRow.querySelector('[data-qty-input]')?.removeAttribute('data-totalavailable');
                    const staleMsgEl = failRow.querySelector('.errormsg');
                    if(staleMsgEl) staleMsgEl.innerHTML = '';
                    const failMsgEl = failRow.querySelector('.errormsgmain');
                    if(failMsgEl) failMsgEl.innerHTML = "Couldn't check stock for this item. Reload the page or remove this line.";
                    return;
                  }
                  if(response.inventory_policy == 'continue' && document.querySelector(`input[value="${variantId}"]`)){
                    if(document.querySelector(`input[value="${variantId}"]`).closest('div')){
                      document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').removeAttribute('data-totalavailable');
                      document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg').innerHTML = '';
                      document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = '';
                    }
                  }
                  if(response.inventory_policy != 'continue'){
                    document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').setAttribute('data-totalavailable',response.available);
                  
                    if(selectedVariant.available == true){
                      let errormsgEl = document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg');
                      errormsgEl.innerHTML = `You can add ${response.available} quantities of this product to cart.`;
                      errormsgEl.classList.remove('d-none');
                      errormsgEl.style.display = '';
                      window.notificationEle.updateNotification('Quick Order', `Available: ${response.available} quantities. You can add up to ${response.available} to cart.`, {
                        timeout: 5000
                      });
                    }else{
                      document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg').innerHTML = '';
                    }
                    if(response.available == 0){
                      document.querySelector(`input[value="${variantId}"]`).closest('div').setAttribute('data-not-consider',"false");
                      document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = 'This product is not available for the selected location.';
                    } else {
                      document.querySelector(`input[value="${variantId}"]`).closest('div').removeAttribute('data-not-consider');
                      document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = '';
                    }
                    // let qtyvalue = parseInt(document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').value);
                    // document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').value = document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').getAttribute('data-fqu');

                    document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-for="increase"]').classList.remove('disabled')

                    let qtyValue = parseInt(document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').value) || 1;
                    let cardEl = event.target.closest('[data-product-listing]');
                    
                    // Calculate effective price based on volume pricing
                    let effectivePrice = selectedVariant.price;
                    let priceBreaksAttr = cardEl.getAttribute('data-price-breaks');
                    
                    if (priceBreaksAttr) {
                      try {
                        let priceBreaks = JSON.parse(priceBreaksAttr);
                        for (let i = priceBreaks.length - 1; i >= 0; i--) {
                          if (qtyValue >= priceBreaks[i].minimum_quantity) {
                            effectivePrice = priceBreaks[i].price;
                            break;
                          }
                        }
                        
                        // Update save percentage badge
                        let savePercentageBadge = cardEl.querySelector('[data-save-percentage]');
                        if (savePercentageBadge) {
                          if (selectedVariant.price > 0 && effectivePrice < selectedVariant.price) {
                            let savePercentage = Math.round(((selectedVariant.price - effectivePrice) / selectedVariant.price) * 100);
                            savePercentageBadge.innerText = `Save ${savePercentage}%`;
                            savePercentageBadge.classList.remove('d-none');
                          } else {
                            savePercentageBadge.classList.add('d-none');
                          }
                        }
                      } catch (e) {
                        console.error('Error parsing price breaks:', e);
                      }
                    }
                    
                    let itemTotalPrice = effectivePrice * qtyValue;
                    cardEl.querySelector('[data-total-price]').innerText = Utility.formatMoney(itemTotalPrice);
                    
                    this.storeQuickListProducts();
                  }
                  
                }).catch((e) => {
                  console.error(e);
                });
              }
            }
      

            
            let cardEl = event.target.closest('[data-product-listing]');
            let qtyVal = parseInt(cardEl.querySelector('[data-qty-input]').value) || 1;
            
            // Calculate effective price based on volume pricing
            let effectivePrice = selectedVariant.price;
            let priceBreaksAttr = cardEl.getAttribute('data-price-breaks');
            
            if (priceBreaksAttr) {
              try {
                let priceBreaks = JSON.parse(priceBreaksAttr);
                // Find the applicable price break tier
                for (let i = priceBreaks.length - 1; i >= 0; i--) {
                  if (qtyVal >= priceBreaks[i].minimum_quantity) {
                    effectivePrice = priceBreaks[i].price;
                    break;
                  }
                }
              } catch (e) {
                console.error('Error parsing price breaks:', e);
              }
            }
            
            cardEl.querySelectorAll('[data-item-price]').forEach(el =>{
              el.setAttribute('data-item-price', effectivePrice);
              el.setAttribute('data-base-price', selectedVariant.price);
            });
            
            // Update unit price display
            let unitPriceEl = cardEl.querySelector('[data-unit-price]');
            if (unitPriceEl) {
              unitPriceEl.innerText = Utility.formatMoney(effectivePrice);
            } else {
              cardEl.querySelector('[data-item-price] p').innerText = Utility.formatMoney(effectivePrice);
            }
            
            // Update save percentage badge
            let savePercentageBadge = cardEl.querySelector('[data-save-percentage]');
            if (savePercentageBadge) {
              if (selectedVariant.price > 0 && effectivePrice < selectedVariant.price) {
                let savePercentage = Math.round(((selectedVariant.price - effectivePrice) / selectedVariant.price) * 100);
                savePercentageBadge.innerText = `Save ${savePercentage}%`;
                savePercentageBadge.classList.remove('d-none');
              } else {
                savePercentageBadge.classList.add('d-none');
              }
            }
            
            let itemTotalPrice = effectivePrice * qtyVal;

            cardEl.querySelector('[data-total-price]').setAttribute('data-total-price', itemTotalPrice)
            cardEl.querySelector('[data-total-price]').innerText = Utility.formatMoney(itemTotalPrice);
            cardEl.setAttribute('data-available',selectedVariant.available);
            this.getTotal();
            

            if(selectedVariant.available == false){
              cardEl.querySelector('[data-error-msg]').innerHTML = `This variant is unavailable. Please select another option. This product will not added to cart while adding.`;
              
            }else{
              cardEl.querySelector('[data-error-msg]').innerHTML = ``;
            }
          }

          this.storeQuickListProducts();

          
        })
      })
      this.bindQty();
      this.bindQuickAdd();
      this.getTotal();
      this.removeProduct();
    }

    storeQuickListProducts() {
      const contentElement = document.querySelector("[data-quick-list-products]");

      if (contentElement) {
        const QuickListProducts = this.minifyHTML(contentElement.innerHTML);

        // Save only if not already stored or content changed
        const existingData = Utility.getLocalStorage("QuickListProducts");
        if (existingData !== QuickListProducts) {
          Utility.setLocalStorage("QuickListProducts", QuickListProducts);
        }
      }
    }

    async retrieveQuickListProducts() {
      const storedHtml = Utility.getLocalStorage("QuickListProducts");

      if (storedHtml) {
        const contentElement = document.querySelector("[data-quick-list-products]");
        if (contentElement) {
          contentElement.innerHTML = storedHtml;
          let productListings = document.querySelectorAll("[data-product-listing]");
          productListings.forEach((element) => {
            // console.log('element==>',element);
            let producData = JSON.parse(element.querySelector('[data-quick-products-json]').innerText);
            let variantIdFromHtml = element.querySelector('[data-quick-variant-id]').value;

            // console.log('selectedVariant444', producData.variants[0]);
            if(Utility.getCookie('locationID') != ''){
              // Rows come back from localStorage, so the stored variant may be gone by now.
              const storedVariant = producData.variants.find(variant => variant.id == variantIdFromHtml);
              if(storedVariant && storedVariant.inventory_management == "shopify"){
                let variantId = storedVariant.id;
                Utility.getVariantInventory(producData.handle, variantId).then(response => {
                  if(response.message){
                    // Stock could not be checked - saying "out of stock" would be a lie, but
                    // shipping an unverified line is worse: /cart/add.js takes the rows as one
                    // atomic batch, so a single bad line fails the buyer's whole order.
                    // data-not-consider="false" is what the collector at the top of this file
                    // filters rows out by.
                    element.setAttribute('data-not-consider', 'false');
                    // The row was restored from localStorage with the last good numbers baked in.
                    // Drop them - "You can add 12" next to "stock unknown" is worse than neither.
                    element.querySelector('[data-qty-input]')?.removeAttribute('data-totalavailable');
                    const staleMsgEl = element.querySelector('.errormsg');
                    if(staleMsgEl) staleMsgEl.innerHTML = '';
                    const failMsgEl = element.querySelector('.errormsgmain');
                    if(failMsgEl) failMsgEl.innerHTML = "Couldn't check stock for this item. Reload the page or remove this line.";
                    return;
                  }
                  // A good check clears whatever a previous failure or stockout left on the row -
                  // the mark is persisted in localStorage with the row, so it has to un-stick.
                  element.removeAttribute('data-not-consider');
                  if(response.inventory_policy == 'continue' && document.querySelector(`input[value="${variantId}"]`)){
                    if(document.querySelector(`input[value="${variantId}"]`).closest('div')){
                      document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('[data-qty-input]').removeAttribute('data-totalavailable');
                      document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg').innerHTML = '';
                      document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = '';
                    }
                  }
                  if(response.inventory_policy != 'continue'){
                    document.querySelector(`input[value="${variantId}"]`)?.closest('div').querySelector('[data-qty-input]').setAttribute('data-totalavailable',response.available);
                    if (document.querySelector(`input[value="${variantId}"]`)) {
                      let errormsgEl = document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsg');
                      errormsgEl.innerHTML = `You can add ${response.available} quantities of this product to cart.`;
                      errormsgEl.classList.remove('d-none');
                      errormsgEl.style.display = '';
                      window.notificationEle.updateNotification('Quick Order', `Available: ${response.available} quantities. You can add up to ${response.available} to cart.`, {
                        timeout: 5000
                      });
                    }
                    if(response.available == 0){
                      document.querySelector(`input[value="${variantId}"]`).closest('div').setAttribute('data-not-consider',"false");
                      document.querySelector(`input[value="${variantId}"]`).closest('div').querySelector('.errormsgmain').innerHTML = 'This product is not available for the selected location.'
                    }
                  }
                  
                }).catch((e) => {
                  console.error(e);
                  window.Rollbar?.error(`File: quick-order-search.js, getting error in fetch inventory on getProductHTML: ${e}`);
                })
              }
            }
          })

          await this.variantChange();
        }
      }
    }

    minifyHTML(html) {
      return html
        .replace(/\s{2,}/g, ' ')
        .replace(/\n/g, '')
        .replace(/\t/g, '')
        .trim();
    }
  }
  
  customElements.define('quick-predictive-search', QuickPredictiveSearch);
  